import React, { FunctionComponent, ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

export type RightSideBarListType = {
  title: string;
  Icon?: FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string | undefined }>;
  link: string;
};

const RightSidebar = ({
  list,
  title,
  children
}: {
  list: RightSideBarListType[];
  title?: string;
  children?: ReactNode;
}) => {
  const { pathname } = useLocation();

  return (
    <div className='px-6 flex flex-col space-y-6 py-4'>
      {title && <p className='text-sm font-medium text-gray-6'>{title}</p>}
      {list?.map(({ Icon, title, link }, i) => {
        return (
          <Link
            to={link}
            replace
            key={i}
            className={`flex items-center gap-[18px] cursor-pointer hover:opacity-90`}>
            <div
              className={`transition-all w-[30px] h-[30px] rounded-full flex items-center justify-center relative ${
                pathname === link ? 'bg-red-5 text-white' : 'border border-gray-13 text-gray-4'
              }`}>
              {Icon && <Icon className='w-[14px] h-[14px' />}
              {list.length - 1 !== i && (
                <div
                  className={`transition-all w-[1px] h-[25px] absolute -bottom-[25px] ${
                    pathname === link ? 'bg-gray-8' : ' bg-gray-13'
                  }`}
                />
              )}
            </div>
            <span
              className={`text-sm transition-all ${
                pathname === link ? 'text-gray-6' : ' text-gray-5'
              }`}>
              {title}
            </span>
          </Link>
        );
      })}
      {children && (
        <div>
          <hr className='text-[#EAEBEB] h-[0.8px] mb-4' />
          {children}
        </div>
      )}
    </div>
  );
};

export default RightSidebar;
